module.exports = __webpack_public_path__ + "static/img/22153C_8_C_20230601_fit.221d002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/22153C_8_C_20230601_fit.png
// module id = QaN3
// module chunks = 0